import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';
import { user, users } from 'user/model/user.fragments';

export const tasksParticipant = gql`
	fragment TasksParticipant on UserOutput {
		...Users
	}
	${users}
`;

export const task = gql`
	fragment Task on TaskOutput {
		id
		done
		type
		owner {
			id
		}
		contact {
			...Contact
		}
		jobOffer {
			...JobOffer
		}
		modulesId
		todoTitle
		dueTimestamp
		updateTimestamp
		participants {
			...TasksParticipant
		}
		todoDescription
		externalEventId
		externalEventTitle
	}
	${tasksParticipant}
	${jobOffer}
	${contact}
`;
